import { render } from "./CadastrosGerais.vue?vue&type=template&id=088c26a4"
import script from "./CadastrosGerais.vue?vue&type=script&lang=js"
export * from "./CadastrosGerais.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__